/**
 * Genera le intestazioni delle colonne per le statistiche settimanali
 * Mostra i periodi di 7 giorni consecutivi invece delle settimane calendariali
 */
export const generateWeeklyColumnHeaders = (): string[] => {
  const headers: string[] = [];
  
  for (let i = 0; i < 7; i++) {
    if (i === 0) {
      headers.push('Ultimi 7gg');
    } else if (i === 1) {
      headers.push('7-13gg fa');
    } else {
      const start = i * 7;
      const end = ((i + 1) * 7) - 1;
      headers.push(`${start}-${end}gg fa`);
    }
  }
  
  return headers;
};

/**
 * Calcola il numero della settimana nell'anno
 */
function getWeekNumber(date: Date): number {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
}